import { render } from "./TheProfessionalExpedientAnamnesisTab.vue?vue&type=template&id=f8de3c2c&scoped=true&ts=true"
import script from "./TheProfessionalExpedientAnamnesisTab.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalExpedientAnamnesisTab.vue?vue&type=script&lang=ts"

import "./TheProfessionalExpedientAnamnesisTab.vue?vue&type=style&index=0&id=f8de3c2c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8de3c2c"]])

export default __exports__